import { useState }  from 'react';
import { Typography, Switch, Box, Paper, Divider } from '@mui/material';
import { useLanguage } from '../../context/LanguageContext';

function NotificationItem({ title, description, checked, onChange }) {
  return (
    <div className="notification-item">
      <Box>
        <Typography className="notification-title">{title}</Typography>
        <Typography className="notification-description">{description}</Typography>
      </Box>
      <Switch 
        className="custom-switch"
        checked={checked}
        onChange={onChange}
      />
    </div>
  );
}

export default function EmailNotifications() {
  const { t } = useLanguage();
  const [notifications, setNotifications] = useState({
    transactionReceived: true,
    transactionSent: true,
    accountChanges: true,
    stakeRewards: true,
  });

  const handleChange = (event) => {
    setNotifications({
      ...notifications,
      [event.target.name]: event.target.checked,
    });
  };

  return (
    <Paper elevation={0} className="notifications-card card">
      <div className="notifications-layout">
        <div className="notifications-title-section">
          <Typography variant="h6" className="notifications-title">
            {t('emailNotifications')}
          </Typography>
        </div>

        <div className="notifications-settings-list">
          <NotificationItem
            title={t('transactionReceived')}
            description={t('transactionReceivedDesc')}
            checked={notifications.transactionReceived}
            onChange={(e) => setNotifications({...notifications, transactionReceived: e.target.checked})}
          />
          <Divider className="notification-divider" />
          
          <NotificationItem
            title={t('transactionSent')}
            description={t('transactionSentDesc')}
            checked={notifications.transactionSent}
            onChange={(e) => setNotifications({...notifications, transactionSent: e.target.checked})}
          />
          <Divider className="notification-divider" />

          <NotificationItem
            title={t('accountChanges')}
            description={t('accountChangesDesc')}
            checked={notifications.accountChanges}
            onChange={(e) => setNotifications({...notifications, accountChanges: e.target.checked})}
          />
          <Divider className="notification-divider" />

          <NotificationItem
            title={t('stakeRewards')}
            description={t('stakeRewardsDesc')}
            checked={notifications.stakeRewards}
            onChange={(e) => setNotifications({...notifications, stakeRewards: e.target.checked})}
          />
        </div>
      </div>
    </Paper>
  );
}